import React from 'react';

export function createContext<T>(name = '', initialValue: T | null): React.Context<T> {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const Context = React.createContext<T>(initialValue!);
    Context.displayName = `${name}Context`;

    return Context;
}
